import { useCharacterCompassStore } from '../store/useCharacterCompassStore';
import { motion, AnimatePresence } from 'framer-motion';

export const MessageContainer = () => {
  const { characterCompassPage, Trait, SubTrait } = useCharacterCompassStore();

  const message = !Trait ? 'initial' : Trait && !SubTrait ? 'trait' : 'subTrait';
  const title = `${message}Title` as 'initialTitle' | 'traitTitle' | 'subTraitTitle';

  // Animation variants for messages
  const variants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
    exit: { opacity: 0 },
  };

  return (
    <div className="mx-auto grid h-full items-center  justify-center">
      <AnimatePresence mode="wait">
        <motion.div
          key={message}
          variants={variants}
          initial="hidden"
          animate="visible"
          exit="hidden"
          transition={{ ease: 'easeOut', duration: 0.5 }}>
          <p key={title} className="text-28-32 mb-sh-30 text-center font-cadiz font-bold">
            {characterCompassPage?.messages?.[title]?.replace('${trait}', SubTrait?.trait || '') || ''}
          </p>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};
